import { useMutation, useSuspenseQuery } from '@tanstack/react-query';
import { toast } from 'sonner';
import { mantangApi as api } from '@/shared/api';
import { MESSAGE } from '@/shared/consts';
import { userKeys } from '../api/user.keys';

const useProfile = () => {
	const { data: profile } = useSuspenseQuery({
		queryFn: async () => {
			const { data } = await api.getUserProfile();
			return data;
		},
		queryKey: userKeys.profile(),
	});

	const { mutate: updateUsername } = useMutation({
		mutationFn: api.updateUsername,
		onSuccess: () => {
			toast.success(MESSAGE.SUCCESS.NICKNAME_CHANGED);
		},
		onError: () => {
			toast.error(MESSAGE.ERROR.NICKNAME_CHANGE_FAILED);
		},
		onSettled: (_, __, ___, ____, context) => {
			context.client.invalidateQueries({ queryKey: userKeys.profile() });
		},
	});

	const { mutate: generateRandomUsername } = useMutation({
		mutationFn: api.generateRandomUsername,
		onError: () => {
			toast.error(MESSAGE.ERROR.RETRY);
		},
	});

	return {
		profile,
		generateRandomUsername,
		updateUsername,
	};
};

export default useProfile;
